var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MaterialGrid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
export const AccountGridContainer = styled((props) => {
    return _jsx(MaterialGrid, Object.assign({}, props, { container: true }));
})(({ theme }) => ({}));
export const AccountGridItem = styled((_a) => {
    var { xs, md } = _a, props = __rest(_a, ["xs", "md"]);
    return _jsx(MaterialGrid, Object.assign({}, props, { item: true, xs: xs || 6, md: md || 3 }));
})(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));
export const AccountContainer = styled('div')(({ theme }) => ({
    '&:not(:last-child)': {
        borderBottom: '3px solid #c5c5c5',
    },
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
}));
export const AccountPaperContainer = styled((props) => _jsx(Paper, Object.assign({}, props, { elevation: 0 })))(({ theme }) => ({
    borderRadius: 0,
    height: '100%',
}));
export const AccountHeader = styled((props) => _jsx(Typography, Object.assign({}, props, { variant: 'h5' })))(({ theme }) => {
    var _a;
    return ({
        marginBottom: theme.spacing(1),
        fontWeight: 800,
        color: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.page.heading,
    });
});
export const AccountSubHeader = styled((props) => _jsx(Typography, Object.assign({}, props)))(({ theme }) => {
    var _a;
    return ({
        fontWeight: 600,
        color: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.page.subHeading,
    });
});
